import {
  AuthenticationApiBaseUrl,
  AuthWsApiBaseUrl,
  CloudProviderApiBaseUrls,
  CpihMessageExporterApiBaseUrl,
  CrashDumpApiBaseUrl,
  PartnerBundleApiBaseUrl,
  TrimbleIdentityApiBaseUrl,
  TripManagementSettingsApiBaseUrl,
} from './api-base-urls';

export class ServiceApiBaseUrls {
  authWsApiBaseUrl!: AuthWsApiBaseUrl;
  authenticationApiBaseUrl!: AuthenticationApiBaseUrl;
  trimbleIdentityApiBaseUrl!: TrimbleIdentityApiBaseUrl;
  tripManagementSettingsApiBaseUrl!: TripManagementSettingsApiBaseUrl;
  cpihMessageExporterApiBaseUrl!: CpihMessageExporterApiBaseUrl;

  cloudProviderApiBaseUrls!: CloudProviderApiBaseUrls;
  crashDumpApiBaseUrl!: CrashDumpApiBaseUrl;
  partnerBundleApiBaseUrl!: PartnerBundleApiBaseUrl;

  constructor(overrides: ServiceApiBaseUrls) {
    Object.assign(this, overrides);
  }
}
